import { useRef ,useState,useEffect} from "react";
import { useInView,motion } from "framer-motion";
import "./view.css";
import about from '../src/images/about.jpg';
import g1a from '../src/images/g1-a.jpg'
import CurrentProjects from "./CurrentProjects";
import g3a from '../src/images/g3-a.jpg'
import g4a from '../src/images/g4-a.jpg'
import g5a from '../src/images/g5-a.jpg'
import g6a from '../src/images/g6-a.jpg';
import g7a from '../src/images/g7-a.jpg';
import g8a from '../src/images/g8-a.jpg';
import g9a from '../src/images/g9-a.jpg';
import g10a from '../src/images/g10-a.jpg';
import g11a from '../src/images/g11-a.jpg';
import g12a from '../src/images/g12-a.jpg';
import g13a from '../src/images/g13-a.jpg';

import point1 from '../src/images/point1.png';
import point2 from '../src/images/point2.png';
import point3 from '../src/images/point3.png';
import point4 from '../src/images/point4.png';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import Plans from './Plans';
import Gallery from "./gallery";
import HowItWorks from "./HowItWorks";
import Services from "./Services";

import DialogForm1 from "./components/DialogForm1";
import Interior from "./Interior";
import CustomizedAccordions from "./Accordian";

export default function Children() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const scrollRef = useRef(null);

  const imageGallery = [
    { src: g1a, location: "Location 1" },
    { src: g10a, location: "Location 10" },
    { src: g6a, location: "Location 6" },
    { src: g3a, location: "Location 3" },
    { src: g12a, location: "Location 11" },
    { src: g5a, location: "Location 5" },
  
    { src: g7a, location: "Location 7" },
    { src: g8a, location: "Location 8" },
    { src: g9a, location: "Location 9" },
  
    { src: g11a, location: "Location 11" },
  {src:g4a,location:"Location 12"},
    { src: g13a, location: "Location 13" },
   
  ];

  

  const scrollByAmount = 420 * 3; // 3 images, each ~400px width + margin

  const showNextImages = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: scrollByAmount, behavior: 'smooth' });
    }
  };

  const showPrevImages = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -scrollByAmount, behavior: 'smooth' });
    }
  };
  

  const openDialogPopup = (index) => {
    setSelectedImageIndex(index);
    setIsDialogOpen(true);
  };

  const closeDialogPopup = () => {
    setIsDialogOpen(false);
  };
  return (
    <>
      <section className="mt-4 mb-4">
        <div   className="d-lg-flex m-5" id="aboutUs" >
        <div>
        <h2 className="pt-4" style={{letterSpacing:'2px',lineHeight:'40px',color:'hsl(255, 93%, 30%)'}}>BuildFortune Construction</h2>
        <h6 style={{color:'rgb(134, 198, 39)',fontSize:'13px',letterSpacing:'1px',fontStyle:'oblique'}}>About us -----------------------------------------------</h6>
        <div style={{textAlign:'justify',color:'black',paddingRight:'20px'}}>
        <p > At BuildFortune Construction, we are committed to guiding every client from concept to creation with integrity, innovation, and impact. Our commitment to excellence and unwavering dedication to client satisfaction set us apart in the competitive world of construction.</p>
        <p >Our core values drive every aspect of our work, Integrity, innovation, and inclusivity are the cornerstones upon which BuildFortune Construction stands. We are committed to transparent communication, cutting-edge technology, and creating an inclusive environment that values diversity.</p>
    </div>
        </div>
        <div className="image-container" style={{position: 'relative', zIndex: '1'}}>
        <img  src={about}  style={{objectFit:'contain'}} />
        <h4 className="abt-text text-white" style={{position:'absolute', top: '0', left: '10px',background:'hsl(255, 93%, 30%)',fontFamily:'monospace',letterSpacing:'1px'}}>100+ <br/>Projects</h4>
    </div>
        </div>
      </section>
   

<section className="mb-4 mt-4">
  <Services/>
</section>

<section>
        <div className="mx-5 mt-5 mb-5" id="features">
        <div className="d-md-flex">
          <div  >
          <h2  style={{letterSpacing:'2px',lineHeight:'30px',color:'hsl(255, 93%, 30%)'}}>What Make Us Different?</h2>
        <h6 style={{color:'rgb(134, 198, 39)',fontSize:'13px',letterSpacing:'1px',fontStyle:'oblique'}}>One stop solution ----------------------------</h6>
          <p  style={{width:'300px',color:'black'}}>Our integrated approach ensures a streamlined process, sparing clients the hassle of coordinating multiple contractors. With a focus on quality and efficiency, we deliver tailored solutions that exceed expectations. Trust us to transform your vision into reality, seamlessly and reliably.</p>
         
          </div>
          <div className="d-grid">
         <div className='d-md-flex'>
          <div className="d-flex">
  <div className="btn p-3">
  <img src={point1} width="70px" ></img>
</div>

<div >
  <h6  style={{color:'rgb(134, 198, 39)'}}>EXCLUSIVE SERVICES</h6>
<p className="text-secondary">We offer a comprehensive suite of exclusive services tailored to cater to every aspect of home construction, ensuring a seamless experience for our clients.</p>
</div>
</div>

<div className="d-flex">
  <div className=" btn p-3">
 <img src={point2} width="70px" ></img>
</div>

<div>
<h6 style={{color:'rgb(134, 198, 39)'}}>PUNCTUALITY PROMISED</h6>
<p className="text-secondary">We are committed to delivering projects on time, adhering strictly to our schedule. In the rare event of any delay, rest assured, we take full responsibility and compensate accordingly.</p>
</div>
</div>


</div >
<div className='d-md-flex'>
<div className="d-flex">
  <div className="btn p-3">
  <img src={point4} width="70px" ></img>
</div>
<div >
  <h6 style={{color:'rgb(134, 198, 39)'}}>TRANSPARENT PRICING</h6>
<p className="text-secondary">Our pricing policy is crystal clear – no hidden charges. Clients receive a single, all-inclusive cost estimate that remains unchanged throughout the project lifecycle.</p>
</div>
</div>
<div className="d-flex">
  <div className="btn p-3">
  <img src={point3} width="70px"></img>
</div>
<div >
<h6 style={{color:'rgb(134, 198, 39)'}}>FULLY INTEGRATED TEAM</h6>
<p className="text-secondary">From architecture to interiors, our fully integrated in-house team handles every aspect of the project, ensuring seamless coordination and superior quality craftsmanship at every step.</p>
</div>
</div>
</div>
 </div>
        </div>
        </div>
      
        </section>

        <section id="projects" style={{backgroundColor:'hsla(255, 93%, 30%,0.4)'}}>
     <h4 className="text-center text-light p-3" style={{position:'relative',top:'30px',left:'0px'}}>Construction</h4> 
      <div className="mb-5 mt-0 image-gallery-container">
        <div
          className="image-gallery-container"
          style={{
            display: 'flex',
            position: 'relative',
            top: '40px',
            justifyContent: 'space-between',
          }}
        >
          <button
            className="p-1"
            style={{
              position: 'absolute',
              top: '40%',
              left: '40px',
              transform: 'translateY(-50%)',
              zIndex: 10,
              border: '1px solid rgb(134, 198, 39)',
              borderRadius: '50px',
              backgroundColor: 'white', 
            }}
            onClick={showPrevImages}
          >
            <ArrowLeftIcon style={{ color: 'rgb(134, 198, 39)', fontSize: '35px' }} />
   
          </button>
       
          <button
            className="p-1"
            style={{
              position: 'absolute',
              top: '40%',
              right: '40px',
              transform: 'translateY(-50%)',
              zIndex: 10,
              border: '1px solid rgb(134, 198, 39)',
              borderRadius: '50px',
              backgroundColor: 'white', // optional
            }}
            onClick={showNextImages}
          >
            <ArrowRightIcon style={{ color: 'rgb(134, 198, 39)', fontSize: '35px' }} />
          </button>
          
        </div>

        <div
          className="image-gallery d-flex"
          ref={scrollRef}
          style={{
            overflowX: 'hidden',
            scrollBehavior: 'smooth',
            gap: '20px',
            marginTop: '20px',
          }}
        >
          {imageGallery.map((image, index) => (
            <div key={index} className="gallery-item" style={{ flex: '0 0 auto' }}>
              <img
                className="projects-gallery"
                src={image.src}
                alt="Construction service gallery"
                style={{ height: '380px', width: '410px', cursor: 'pointer' }}
                onClick={() => openDialogPopup(index)}
              />
            </div>
          ))}
        </div>
      </div>
     {/* <h4 className="text-center text-light p-1" style={{backgroundColor:'hsla(255, 93%, 30%,0.7)',position:'relative',bottom:'47.5px',left:'0px'}}></h4>  */}

      <DialogForm1
        isOpen={isDialogOpen}
        onClose={closeDialogPopup}
        imageIndex={selectedImageIndex}
      />
    </section>

<section className="mt-5">
  <Interior/>
</section>
<section>
 <HowItWorks/>

</section>  
 <section className="mt-5 mb-5">
  <Gallery/>
</section> 
{/* <section>
  <CurrentProjects/>
</section>  */}

<section className="mt-5 mb-5" id="faq">
<div  className="d-md-flex" style={{justifyContent:"space-between"}}>
        <div style={{paddingTop:'100px'}}>
        <h1 className="text-center"><i class="bi bi-patch-question" style={{color:"rgb(134, 198, 39)", fontSize:"55px"}}></i><br></br>Frequently asked questions</h1>

        </div>
       
          <CustomizedAccordions/>
          </div>
</section>  
    </>
  );
}
